import api, { _axios } from "./api";

export default class MeetingProgramReviewApi {
  static async Get(data) {
    return await api.get(`meeting-program-review`, data);
  }

  static async GetDetail(id) {
    return await api.get(`meeting-program-review/${id}`);
  }

  static async PostActivation(id, data) {
    return await api.post(`meeting-program-review/activation/${id}`, data);
  }

  static async Del(id) {
    return await api.del(`meeting-program-review/${id}`);
  }
}
